(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-background"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-background')) {
    customElements.define(
      'video-background',
      class VideoBackground extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');

          if (!this.video) return;

          this.video.muted = true;
          this.video.defaultMuted = true;

          const showVideo = () => this.classList.add('is-loaded');

          if (this.video.readyState >= 2) {
            showVideo();
          } else {
            this.video.addEventListener('loadeddata', showVideo, { once: true });
          }

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.video.pause();
            return;
          }

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  const playPromise = this.video.play();

                  if (playPromise !== undefined) {
                    playPromise.catch(() => {});
                  }
                } else {
                  this.video.pause();
                }
              });
            },
            { threshold: 0.15 }
          );

          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) {
            this.observer.disconnect();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-prezentare"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-video-player')) {
    customElements.define(
      'custom-video-player',
      class CustomVideoPlayer extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.button = this.querySelector('.video-presentation__play');

          if (!this.video || !this.button) return;

          this.handlePlayClick = () => {
            this.video.muted = false;
            this.video.play().catch(() => {});
          };

          this.handlePlay = () => {
            this.classList.add('is-playing');
          };

          this.handlePause = () => {
            if (!this.video.ended) return;
            this.classList.remove('is-playing');
          };

          this.handleEnded = () => {
            this.classList.remove('is-playing');
          };

          this.button.addEventListener('click', this.handlePlayClick);
          this.video.addEventListener('play', this.handlePlay);
          this.video.addEventListener('pause', this.handlePause);
          this.video.addEventListener('ended', this.handleEnded);
        }

        disconnectedCallback() {
          if (!this.video || !this.button) return;

          this.button.removeEventListener('click', this.handlePlayClick);
          this.video.removeEventListener('play', this.handlePlay);
          this.video.removeEventListener('pause', this.handlePause);
          this.video.removeEventListener('ended', this.handleEnded);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
